import React, { useState } from 'react';
import { Popup } from 'reactjs-popup';
import StripeCheckout from 'react-stripe-checkout';

const SMS_URL    = 'https://datingggo-d609631f502c.herokuapp.com/send-smsd';
const PAY_URL    = 'https://learntok-backend-2026-24c204fe508e.herokuapp.com/partyevents/paycharge';
const ADMIN      = '+18062248515';
const STRIPE_KEY = 'pk_live_51KLZlpDW3FwkTm7hlBeiuq9CrbzprsKJ6japvWBhrcaJvY7i4jhzBFvPj1bCOJmYX5mpQDU3FXL2jB8zR1TphQkZ00sCZhaEsZ';

const Pay = ({ username, selectedPrice, onClose, onSuccess, isOpen }) => {
  const [isLoading, setIsLoading]       = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [phoneNumber, setPhoneNumber]   = useState('');
  const [streetAddress, setStreetAddress] = useState(''); // used as email field
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [notified, setNotified]         = useState(false);

  const price = (selectedPrice !== null && selectedPrice !== undefined)
    ? (() => {
        const n = parseFloat(String(selectedPrice).replace(/[^0-9.]/g, ''));
        return Number.isFinite(n) && n >= 0 ? n : 10;
      })()
    : 10;

  // ── Admin SMS helpers ──────────────────────────────────────────────────────
  const sms = async (to, message) => {
    try {
      await fetch(SMS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: [{ phoneNumber: to, message }] }),
      });
    } catch (_) {}
  };

  const notifyCheckoutStarted = () => {
    if (notified) return;
    setNotified(true);
    sms(ADMIN, `👀 Checkout started!\nProduct: ${username}\nPrice: $${price.toFixed(2)}`);
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  // Dev-only bypass — visible on localhost or with ?test=1, skips Stripe entirely
  const isTestMode = (typeof window !== 'undefined') && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    new URLSearchParams(window.location.search).get('test') === '1'
  );

  const handleClose   = (status = null) => { if (onClose) onClose(status); };
  const handleSuccess = (status = 'success') => {
    setPaymentStatus(status);
    if (onSuccess) onSuccess(status);
    else if (onClose) onClose(status);
  };

  const handleToken = async (token) => {
    setIsLoading(true);
    try {
      if (price === 0) { handleSuccess('success'); setIsLoading(false); return; }

      const res = await fetch(PAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username,
          amount: price,           // dollars — server multiplies by 100
          token: token.id,
          email: token.email,
          customerName,
          phoneNumber,
          streetAddress: '',
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && data.ok) {
        await sms(ADMIN, `💰 Payment success!\nProduct: ${username}\nPrice: $${price.toFixed(2)}\nCustomer: ${customerName}\nEmail: ${token.email}\nPhone: ${phoneNumber}\nCharge: ${data.chargeId || 'n/a'}`);
        handleSuccess('success');
      } else {
        await sms(ADMIN, `❌ Payment failed!\nProduct: ${username}\nPrice: $${price.toFixed(2)}\nCustomer: ${customerName}\nEmail: ${token.email}\nError: ${data.error || 'Unknown error'}`);
        alert(data.error || 'Payment failed. Please try again.');
        handleClose('failed');
      }
    } catch (e) {
      await sms(ADMIN, `❌ Payment error!\nProduct: ${username}\nError: ${e.message}`);
      alert('An error occurred during payment. Please try again later.');
      handleClose('error');
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '12px', marginBottom: '12px',
    borderRadius: '8px', border: '1px solid #e2e8f0',
    backgroundColor: '#f9fafb', fontSize: '15px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'inherit',
  };

  return (
    <Popup
      open={isOpen}
      modal
      closeOnDocumentClick={false}
      contentStyle={{
        padding: '30px', borderRadius: '16px', width: '380px',
        maxHeight: '85vh', overflowY: 'auto',
        background: 'linear-gradient(135deg,#ffffff 0%,#f8fafc 100%)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
        position: 'relative',
        fontFamily: "'Inter',-apple-system,BlinkMacSystemFont,sans-serif",
      }}
    >
      <div>
        {/* Close */}
        <button onClick={() => handleClose(paymentStatus)} style={{ position:'absolute',top:'16px',right:'16px',background:'#ef4444',color:'#fff',border:'none',borderRadius:'50%',width:'32px',height:'32px',cursor:'pointer',fontSize:'18px',fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center' }}>×</button>

        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:'20px', paddingTop:'8px' }}>
          <div style={{ display:'inline-block',background:'#ede9fe',color:'#7c3aed',fontSize:'11px',fontWeight:'700',letterSpacing:'.08em',textTransform:'uppercase',padding:'4px 12px',borderRadius:'100px',marginBottom:'12px' }}>
            You're purchasing
          </div>
          <h3 style={{ fontSize:'20px',fontWeight:'700',color:'#1f2937',marginBottom:'8px',lineHeight:'1.3' }}>{username}</h3>
          <div style={{ fontSize:'32px',fontWeight:'800',color:'#4f46e5',letterSpacing:'-.02em' }}>${price.toFixed(2)}</div>
          <p style={{ fontSize:'12px',color:'#9ca3af',marginTop:'4px' }}>One-time payment · USD</p>
        </div>

        <div style={{ height:'1px',background:'#f3f4f6',marginBottom:'20px' }}/>

        <form>
          <input
            type="text" placeholder="Your Name" value={customerName}
            onChange={e => setCustomerName(e.target.value)}
            onFocus={notifyCheckoutStarted}
            style={inputStyle}
          />
          <input
            type="email" placeholder="Email address" value={streetAddress}
            onChange={e => setStreetAddress(e.target.value)}
            onFocus={notifyCheckoutStarted}
            style={inputStyle}
          />
          <input
            type="text" placeholder="Phone Number" value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
            onFocus={notifyCheckoutStarted}
            style={{ ...inputStyle, marginBottom: '20px' }}
          />

          {isTestMode && (
            <button
              type="button"
              onClick={() => { sms(ADMIN, `🧪 TEST payment (no charge)\nProduct: ${username}\nPrice: $${price.toFixed(2)}`); handleSuccess('success'); }}
              style={{ width: '100%', background: '#FEF3C7', color: '#92400E', border: '1.5px dashed #F59E0B', padding: '10px 0', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '700', marginBottom: '10px' }}
            >
              🧪 Test Mode — Skip Payment
            </button>
          )}

          {price === 0 ? (
            <button type="button" onClick={() => handleSuccess('success')} disabled={isLoading}
              style={{ background:'linear-gradient(to right,#3b82f6,#2563eb)',color:'#fff',padding:'14px 24px',border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'16px',fontWeight:'600',width:'100%' }}>
              {isLoading ? 'Processing…' : 'Place Order'}
            </button>
          ) : (
            <StripeCheckout
              token={handleToken}
              stripeKey={STRIPE_KEY}
              amount={price * 100} name={username}
              description={`$${price.toFixed(2)} · Personal use`}
              currency="USD" disabled={isLoading}
              email={streetAddress || undefined}
            >
              <button type="button" disabled={isLoading}
                style={{ background:'linear-gradient(to right,#4f46e5,#7c3aed)',color:'#fff',padding:'14px 24px',border:'none',borderRadius:'10px',cursor:'pointer',fontSize:'16px',fontWeight:'700',width:'100%',letterSpacing:'-.01em' }}>
                {isLoading ? 'Processing…' : `Pay $${price.toFixed(2)} →`}
              </button>
            </StripeCheckout>
          )}
        </form>

        <div style={{ display:'flex',justifyContent:'center',gap:'16px',marginTop:'16px',flexWrap:'wrap' }}>
          {['🔒 Secure','⚡ Instant','💬 Support'].map(t => (
            <span key={t} style={{ fontSize:'11px',color:'#9ca3af' }}>{t}</span>
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default Pay;